import "bootstrap/dist/js/bootstrap.bundle.min.js";
import sal from "sal.js";

document.addEventListener("DOMContentLoaded", () => {
	sal();

	// Skip link focus handling for accessibility
	const skipLink = document.querySelector('a[href="#content"]');
	if (skipLink) {
		skipLink.addEventListener("click", (e) => {
			e.preventDefault();
			const target = document.querySelector("#content");
			if (target) {
				target.setAttribute("tabindex", "-1");
				target.focus();
				target.addEventListener(
					"blur",
					() => {
						target.removeAttribute("tabindex");
					},
					{ once: true },
				);
			}
		});
	}

	// SPで hover クラスを付与
	document.querySelectorAll(".js_h").forEach((jsh) => {
		["mouseenter", "touchstart", { passive: true }].forEach((event) => {
			jsh.addEventListener(event, () => {
				jsh.classList.add("hover");
			});
		});
		["mouseleave", "touchend", { passive: true }].forEach((event) => {
			jsh.addEventListener(event, () => {
				jsh.classList.remove("hover");
			});
		});
	});

	const observerOptions = {
		root: null,
		rootMargin: "0px",
		threshold: 0.2, // 20%見えたら実行
	};

	const observer = new IntersectionObserver((entries) => {
		entries.forEach((entry) => {
			if (entry.isIntersecting) {
				// 視界に入ったらクラスを付与
				entry.target.classList.add("is-active");
				// 一度表示されたら監視を解除（1回きりの場合）
				observer.unobserve(entry.target);
			}
		});
	}, observerOptions);

	// 対象のボタンをすべて監視
	const targets = document.querySelectorAll(".js-scroll-show");
	targets.forEach((target) => observer.observe(target));

	// スクロールが100に達したらページの先頭に戻るボタン表示
	const ywsa = document.getElementById("page-top");
	const yws_pagetop = function () {
		if (window.pageYOffset > 100) {
			ywsa.classList.add("fixed");
		} else {
			ywsa.classList.remove("fixed");
		}
	};
	// ページ内スムーススクロール
	window.addEventListener("load", yws_pagetop);
	window.addEventListener("scroll", yws_pagetop);
	ywsa.addEventListener("click", (e) => {
		e.preventDefault();
		window.scroll({
			top: 0,
			behavior: "smooth",
		});
	});
});
